var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"push-cancel"},[_vm._v(_vm._s(_vm.title)),_c('Btn',{on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }